import React, { useEffect, useMemo, useState } from 'react';
import { Megaphone, Truck, RefreshCw, ShieldCheck } from 'lucide-react';
import { useSettings } from '../contexts/SettingsContext';

export const AnnouncementBar: React.FC = () => {
  const { settings } = useSettings();
  const [currentIndex, setCurrentIndex] = useState(0);

  const announcements = useMemo(() => {
    const raw = settings?.infoBarText || '';
    // Split by dot / pipe / bullet to allow multiple messages from admin
    const parts = raw.split(/·|\||•/).map((p) => p.trim()).filter(Boolean);

    if (parts.length === 0) {
      return [
        { icon: Truck, text: 'Pan-India delivery on every order' },
        { icon: RefreshCw, text: 'Easy, free returns—no questions asked' },
        { icon: ShieldCheck, text: 'Secure checkout & quality assured' },
      ];
    }

    const iconCycle = [Megaphone, Truck, RefreshCw, ShieldCheck];
    return parts.map((text, idx) => ({ icon: iconCycle[idx % iconCycle.length], text }));
  }, [settings?.infoBarText]);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % announcements.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);

  const CurrentIcon = announcements[currentIndex].icon;
  return (
    <div
      id="announcement-bar"
      className="overflow-hidden border-b border-white/10 bg-text py-2 text-background"
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-center gap-2 animate-fade-in text-center">
          <CurrentIcon className="h-4 w-4 text-accent" />
          <p className="text-sm font-normal tracking-[0.08em]">
            {announcements[currentIndex].text}
          </p>
        </div>
      </div>
    </div>
  );
};
